type TClass = string | undefined | false | null;

export default function resolvedClassName(...classes: TClass[]) {
	return classes.filter(Boolean).join(' ');
}